import { Space, Tooltip } from 'antd';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import React from 'react';
import { useDictionaryTranslation } from '../../hooks/useDictionaryTranslation';
import { Button } from '../buttons/buttons';

const CreateItemByInput = ({
  editText = 'edit',
  createText = 'create',
  onEdit,
  onCreate,
  disableEdit,
  disableCreate,
}) => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <>
        <Space size="small">
          <Tooltip title={t(createText)}>
            <Button type="secondary" size="large" onClick={onCreate} disabled={disableCreate}>
              <FeatherIcon icon="plus" />
            </Button>
          </Tooltip>
          <Tooltip title={t(editText)}>
            <Button type="secondary" size="large" onClick={onEdit} disabled={disableEdit}>
              <FeatherIcon icon="edit" />
            </Button>
          </Tooltip>
        </Space>
    </>
  );
};

export default CreateItemByInput;

CreateItemByInput.propTypes = {
  editText: PropTypes.string,
  createText: PropTypes.string,
  onEdit: PropTypes.func,
  onCreate: PropTypes.func,
  disableEdit: PropTypes.bool,
  disableCreate: PropTypes.bool,
};
